export const selectPlaybackIsOpen = (state) => state.playback.isOpen;
export const selectPlaybackUrl = (state) => state.playback.url;
export const selectPlaybackIsLoading = (state) => state.playback.isLoading;
export const selectPlaybackError = (state) => state.playback.error;
export const selectPlaybackActiveCamId = (state) => state.playback.activeCamId;
export const selectPlaybackCameraName = (state) => state.playback.cameraName;
export const selectPlaybackIsVideoPlaying = (state) => state.playback.isVideoPlaying;
export const selectPlaybackTransactionId = (state) => state.playback.transactionId;
